import { Domain, StudyDocumentsFile, StudyDocumentsService } from '@csp/csp-common-file-storage';
import { ContentUtil } from '@csp/csp-common-content';
import { FileUtil } from '../../../common/util/FileUtil';
import { StaticContentService } from '../../../common/service/StaticContentService';
import { StudyDocumentsConstants } from '../model/StudyDocumentsConstants';

const downloadFile = FileUtil.createDownloadFileHandler(StudyDocumentsService.getBinaryFileData);

const getDomainCmsContent = (domain: Domain): string => {
  const domainTexts = StaticContentService.getGenericBlock('webHcpDocumentRepository', 'domain');
  return ContentUtil.mapEnum(domain, domainTexts);
};

const fileIsViewable = (studyDocument: StudyDocumentsFile): boolean =>
  StudyDocumentsConstants.VIEWABLE_FILE_EXTENSION.some(viewableFileExt => studyDocument.name.endsWith(viewableFileExt));

export const StudyDocsUtil = {
  downloadFile,
  getDomainCmsContent,
  fileIsViewable,
};
